export const FIRST_SLASH_AFTER_PROTOCOL = 3;

export const COACH_TOOLKIT_URL =
  'https://mentoteam.notion.site/Mento-Coach-Toolkit-eb435081ff2e4f7b9176884eccb4e63c';
